<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}" @failure="formFailure"
            :save-params="{api_key: currentUser.api_key}">
        <div class="col-12">
            <validated-input name="Name" label="Name" v-model="model.name"
                             :rules="{required:true}" :disabled="loading"/>
        </div>
        <div class="col-12 mt-2">
            <btn class="trn" size="sm" :loading="loading" color="primary" text="Save"
                 loading-text="Saving..." :disabled="loading"/>
        </div>
    </b-form>
</template>

<script>
import urls from '../../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name     : 'AddBlogCategory',
    computed : { ...mapGetters(['currentUser']) },
    data () {
        return {
            addUrl : urls.admin.blogCategory.addEdit
        };
    },

    methods : {
        formSuccess () {
            this.$notify('Successfully Added Blog Category..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        },
        formFailure (response) {
            const json = response.data;
            if (json.permission === false) {
                this.$notify('Invalid Authentication..!', 'Permission Denied',
                    {
                        type : 'warning'
                    }
                );
            }
        }
    }
};
</script>

<style scoped>

</style>
